module.exports = __webpack_public_path__ + "static/media/loading.66ad9a0f.svg";